export function SocialPlatforms() {
  const platforms = [
    {
      name: 'Quora',
      icon: 'ri-quora-fill',
      description: 'In-depth answers to arranged marriage questions',
      color: 'from-red-600 to-red-700',
      bgColor: 'bg-red-50',
      link: '#'
    },
    {
      name: 'Reddit',
      icon: 'ri-reddit-fill',
      description: 'Community discussions and real experiences',
      color: 'from-orange-600 to-orange-700',
      bgColor: 'bg-orange-50',
      link: '#'
    },
    {
      name: 'X (Twitter)',
      icon: 'ri-twitter-x-fill',
      description: 'Quick insights and daily clarity tips',
      color: 'from-gray-800 to-gray-900',
      bgColor: 'bg-gray-50',
      link: '#'
    },
    {
      name: 'Substack',
      icon: 'ri-newspaper-line',
      description: 'Deep-dive articles and clarity blogs',
      color: 'from-amber-600 to-orange-700',
      bgColor: 'bg-amber-50',
      link: '#'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <div className="flex items-center gap-2 px-4 py-2 bg-rose-100 rounded-full">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-share-line text-xl text-rose-800"></i>
              </div>
              <span className="text-sm font-semibold text-rose-800 uppercase tracking-wide">Connect With Us</span>
            </div>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900" style={{ fontFamily: "'Cinzel', serif" }}>
            Find Us on Your Favorite <strong className="text-rose-800">Platforms</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join our community across multiple platforms for daily insights, discussions, and <strong className="text-rose-700">clarity</strong> guidance
          </p>
        </div>

        {/* Platforms Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {platforms.map((platform, index) => (
            <a
              key={index}
              href={platform.link}
              className="group bg-white rounded-2xl p-8 border-2 border-rose-100 hover:border-rose-300 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className={`w-20 h-20 flex items-center justify-center bg-gradient-to-br ${platform.color} rounded-2xl mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${platform.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{platform.name}</h3>
              <p className="text-gray-600 mb-4">{platform.description}</p>
              <div className="flex items-center gap-2 text-rose-700 font-semibold group-hover:gap-3 transition-all">
                <span>Visit Platform</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </div>
            </a>
          ))}
        </div>

        {/* AI Agent Highlight */}
        <div className="bg-gradient-to-br from-rose-50 via-amber-50/50 to-rose-50 rounded-3xl p-12 border-2 border-rose-200">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-rose-800 to-red-900 rounded-2xl mx-auto mb-6">
              <i className="ri-robot-2-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Cinzel', serif" }}>
              AI <strong className="text-rose-800">Clarity</strong> Assistant
            </h3>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Get instant answers to your <strong className="text-rose-700">arranged marriage clarity</strong> questions through our AI-powered assistant. Available 24/7 to provide guidance and support on your journey.
            </p>
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-rose-800 to-red-900 text-white rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-chat-4-line text-xl"></i>
              </div>
              Chat with AI Assistant
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
